import { computed as c, defineComponent as tn, h as nn, ref as S, watchEffect as Fn, onBeforeMount as On, onBeforeUpdate as Un, useSlots as wn, useAttrs as Dn, markRaw as ln, watch as P, onMounted as Hn, nextTick as dn, createElementBlock as pn, openBlock as O, mergeProps as kn, renderSlot as G, normalizeProps as L, guardReactiveProps as N, createBlock as Z, resolveDynamicComponent as W, unref as h, createSlots as $n, withCtx as V, createVNode as Zn, createElementVNode as yn, toDisplayString as X, createCommentVNode as Wn, renderList as Cn } from "vue";
import { getSupportedRegionCodes as _n, getCountryCodeForRegionCode as zn, parsePhoneNumber as _, getExample as Sn } from "awesome-phonenumber";
import { VTextField as vn, VSelect as Jn, VListItem as mn } from "vuetify/components";
function Mn() {
  return {
    country: {
      required: !0,
      type: Object
    },
    decorative: {
      type: Boolean,
      default: !1
    }
  };
}
function fn({ props: n }) {
  const e = c(() => n.decorative ? void 0 : "img"), a = c(() => n.decorative ? void 0 : n.country.name);
  return { role: e, title: a };
}
const xn = tn({
  props: Mn(),
  setup(n) {
    const { role: e, title: a } = fn({ props: n });
    return () => nn("span", {
      role: e.value,
      title: a.value,
      class: ["v-phone-input__country__icon", "f32"]
    }, nn("span", { class: ["flag", n.country.iso2.toLowerCase()] }));
  }
}), Yn = tn({
  props: Mn(),
  setup(n) {
    const { role: e, title: a } = fn({ props: n });
    return () => nn("span", {
      role: e.value,
      title: a.value,
      class: [
        "v-phone-input__country__icon",
        "fi",
        `fi-${n.country.iso2.toLowerCase()}`
      ]
    });
  }
});
function Qn(n) {
  return "setPreference" in n;
}
function U(n) {
  return n && typeof n == "object" ? n.iso2 : (n || "").toUpperCase();
}
function jn({ props: n }) {
  const e = _n(), a = S({}), r = S(0), d = S([]), o = S([]), $ = c(() => n.preferCountries.map(U)), y = c(() => n.includeCountries.map(U)), R = c(() => n.excludeCountries.map(U));
  Fn(() => {
    const p = {}, K = [], F = [];
    n.allCountries.forEach((C) => {
      const M = U(C.iso2);
      if (e.indexOf(M) === -1 || y.value.length && y.value.indexOf(M) === -1 || R.value.indexOf(M) !== -1)
        return;
      const I = { ...C, iso2: M };
      p[I.iso2] = I, $.value.indexOf(M) !== -1 ? K.push(I) : F.push(I);
    }), K.sort((C, M) => $.value.indexOf(C.iso2) - $.value.indexOf(M.iso2)), a.value = p, d.value = K, o.value = F, r.value = K.length + F.length, r.value || console.error('[v-phone-input] resulting countries from "allCountries", "includeCountries" and "excludeCountries" must be a non-empty list');
  });
  const w = c(() => {
    const p = d.value[0] ?? o.value[0];
    return p ? a.value[p.iso2] : void 0;
  }), E = (p) => a.value[U(p)], B = S(!1), D = c(() => !n.disableGuessLoading && B.value);
  return {
    countriesCount: r,
    preferredCountries: d,
    otherCountries: o,
    guessingCountry: D,
    findCountry: E,
    firstCountry: w,
    setCountryPreference: (p) => {
      B.value = !1, Qn(n.countryGuesser) && n.countryGuesser.setPreference(p);
    },
    guessCountry: async () => {
      if (!n.guessCountry)
        return;
      B.value = !0;
      const p = E(await n.countryGuesser.guess());
      return B.value = !1, p == null ? void 0 : p.iso2;
    }
  };
}
function Xn({ props: n }) {
  return { countryIconComponent: c(() => {
    switch (n.countryIconMode) {
      case "svg":
        return Yn;
      case "sprite":
        return xn;
      case "text":
        return;
      default:
        return n.countryIconMode;
    }
  }) };
}
function qn({ props: n }) {
  return { countrySelectComponent: c(() => n.enableSearchingCountry ? {
    type: "VAutocomplete",
    props: {
      autocomplete: "new-password",
      "aria-autocomplete": "off",
      filterKeys: ["raw.name", "raw.iso2", "raw.dialCode"]
    }
  } : {
    type: "VSelect",
    props: {}
  }) };
}
function nt({ props: n, country: e, example: a }) {
  const r = (T, H) => typeof T == "function" ? T(H) : T, d = c(() => ({ country: e.value, example: a.value })), o = c(() => r(n.label, d.value)), $ = c(() => r(n.ariaLabel, d.value)), y = c(() => ({
    ...d.value,
    label: o.value || $.value
  })), R = c(() => r(n.countryLabel, y.value)), w = c(
    () => r(n.countryAriaLabel, y.value)
  ), E = c(() => r(n.placeholder, y.value)), B = c(() => r(n.hint, y.value)), D = c(
    () => r(n.invalidMessage, y.value)
  );
  return {
    label: o,
    ariaLabel: $,
    countryLabel: R,
    countryAriaLabel: w,
    placeholder: E,
    hint: B,
    invalidMessage: D,
    messageOptions: d
  };
}
function tt(n, e) {
  const a = S({}), r = () => {
    const d = {};
    Object.keys(n).forEach((o) => {
      const [$, ...y] = o.split(":");
      !y.length || e.indexOf($) === -1 ? d.default = {
        ...d.default || {},
        [o]: o
      } : d[$] = {
        ...d[$] || {},
        [y.join(":")]: o
      };
    }), a.value = d;
  };
  return On(r), Un(r), { namespacedSlots: a };
}
const ot = "Andorra", et = "United Arab Emirates", at = "Afghanistan", st = "Antigua and Barbuda", ct = "Anguilla", rt = "Albania", it = "Armenia", ut = "Angola", lt = "Antarctica", dt = "Argentina", pt = "American Samoa", $t = "Austria", yt = "Australia", Ct = "Aruba", vt = "Aland", mt = "Azerbaijan", St = "Bosnia and Herzegovina", Mt = "Barbados", ft = "Bangladesh", gt = "Belgium", ht = "Burkina Faso", It = "Bulgaria", Gt = "Bahrain", Bt = "Burundi", Tt = "Benin", At = "Saint Barthelemy", Pt = "Bermuda", bt = "Brunei", Lt = "Bolivia", Nt = "Bonaire", Vt = "Brazil", Rt = "Bahamas", Et = "Bhutan", Kt = "Bouvet Island", Ft = "Botswana", Ot = "Belarus", Ut = "Belize", wt = "Canada", Dt = "Cocos (Keeling) Islands", Ht = "Democratic Republic of the Congo", kt = "Central African Republic", Zt = "Republic of the Congo", Wt = "Switzerland", _t = "Ivory Coast", zt = "Cook Islands", Jt = "Chile", xt = "Cameroon", Yt = "China", Qt = "Colombia", jt = "Costa Rica", Xt = "Cuba", qt = "Cape Verde", no = "Curacao", to = "Christmas Island", oo = "Cyprus", eo = "Czech Republic", ao = "Germany", so = "Djibouti", co = "Denmark", ro = "Dominica", io = "Dominican Republic", uo = "Algeria", lo = "Ecuador", po = "Estonia", $o = "Egypt", yo = "Western Sahara", Co = "Eritrea", vo = "Spain", mo = "Ethiopia", So = "Finland", Mo = "Fiji", fo = "Falkland Islands", go = "Micronesia", ho = "Faroe Islands", Io = "France", Go = "Gabon", Bo = "United Kingdom", To = "Grenada", Ao = "Georgia", Po = "French Guiana", bo = "Guernsey", Lo = "Ghana", No = "Gibraltar", Vo = "Greenland", Ro = "Gambia", Eo = "Guinea", Ko = "Guadeloupe", Fo = "Equatorial Guinea", Oo = "Greece", Uo = "South Georgia and the South Sandwich Islands", wo = "Guatemala", Do = "Guam", Ho = "Guinea-Bissau", ko = "Guyana", Zo = "Hong Kong", Wo = "Heard Island and McDonald Islands", _o = "Honduras", zo = "Croatia", Jo = "Haiti", xo = "Hungary", Yo = "Indonesia", Qo = "Ireland", jo = "Israel", Xo = "Isle of Man", qo = "India", ne = "British Indian Ocean Territory", te = "Iraq", oe = "Iran", ee = "Iceland", ae = "Italy", se = "Jersey", ce = "Jamaica", re = "Jordan", ie = "Japan", ue = "Kenya", le = "Kyrgyzstan", de = "Cambodia", pe = "Kiribati", $e = "Comoros", ye = "Saint Kitts and Nevis", Ce = "North Korea", ve = "South Korea", me = "Kuwait", Se = "Cayman Islands", Me = "Kazakhstan", fe = "Laos", ge = "Lebanon", he = "Saint Lucia", Ie = "Liechtenstein", Ge = "Sri Lanka", Be = "Liberia", Te = "Lesotho", Ae = "Lithuania", Pe = "Luxembourg", be = "Latvia", Le = "Libya", Ne = "Morocco", Ve = "Monaco", Re = "Moldova", Ee = "Montenegro", Ke = "Saint Martin", Fe = "Madagascar", Oe = "Marshall Islands", Ue = "North Macedonia", we = "Mali", De = "Myanmar (Burma)", He = "Mongolia", ke = "Macao", Ze = "Northern Mariana Islands", We = "Martinique", _e = "Mauritania", ze = "Montserrat", Je = "Malta", xe = "Mauritius", Ye = "Maldives", Qe = "Malawi", je = "Mexico", Xe = "Malaysia", qe = "Mozambique", na = "Namibia", ta = "New Caledonia", oa = "Niger", ea = "Norfolk Island", aa = "Nigeria", sa = "Nicaragua", ca = "Netherlands", ra = "Norway", ia = "Nepal", ua = "Nauru", la = "Niue", da = "New Zealand", pa = "Oman", $a = "Panama", ya = "Peru", Ca = "French Polynesia", va = "Papua New Guinea", ma = "Philippines", Sa = "Pakistan", Ma = "Poland", fa = "Saint Pierre and Miquelon", ga = "Pitcairn Islands", ha = "Puerto Rico", Ia = "Palestine", Ga = "Portugal", Ba = "Palau", Ta = "Paraguay", Aa = "Qatar", Pa = "Reunion", ba = "Romania", La = "Serbia", Na = "Russia", Va = "Rwanda", Ra = "Saudi Arabia", Ea = "Solomon Islands", Ka = "Seychelles", Fa = "Sudan", Oa = "Sweden", Ua = "Singapore", wa = "Saint Helena", Da = "Slovenia", Ha = "Svalbard and Jan Mayen", ka = "Slovakia", Za = "Sierra Leone", Wa = "San Marino", _a = "Senegal", za = "Somalia", Ja = "Suriname", xa = "South Sudan", Ya = "Sao Tome and Principe", Qa = "El Salvador", ja = "Sint Maarten", Xa = "Syria", qa = "Eswatini", ns = "Turks and Caicos Islands", ts = "Chad", os = "French Southern Territories", es = "Togo", as = "Thailand", ss = "Tajikistan", cs = "Tokelau", rs = "East Timor", is = "Turkmenistan", us = "Tunisia", ls = "Tonga", ds = "Turkey", ps = "Trinidad and Tobago", $s = "Tuvalu", ys = "Taiwan", Cs = "Tanzania", vs = "Ukraine", ms = "Uganda", Ss = "U.S. Minor Outlying Islands", Ms = "United States", fs = "Uruguay", gs = "Uzbekistan", hs = "Vatican City", Is = "Saint Vincent and the Grenadines", Gs = "Venezuela", Bs = "British Virgin Islands", Ts = "U.S. Virgin Islands", As = "Vietnam", Ps = "Vanuatu", bs = "Wallis and Futuna", Ls = "Samoa", Ns = "Kosovo", Vs = "Yemen", Rs = "Mayotte", Es = "South Africa", Ks = "Zambia", Fs = "Zimbabwe", Os = {
  AD: ot,
  AE: et,
  AF: at,
  AG: st,
  AI: ct,
  AL: rt,
  AM: it,
  AO: ut,
  AQ: lt,
  AR: dt,
  AS: pt,
  AT: $t,
  AU: yt,
  AW: Ct,
  AX: vt,
  AZ: mt,
  BA: St,
  BB: Mt,
  BD: ft,
  BE: gt,
  BF: ht,
  BG: It,
  BH: Gt,
  BI: Bt,
  BJ: Tt,
  BL: At,
  BM: Pt,
  BN: bt,
  BO: Lt,
  BQ: Nt,
  BR: Vt,
  BS: Rt,
  BT: Et,
  BV: Kt,
  BW: Ft,
  BY: Ot,
  BZ: Ut,
  CA: wt,
  CC: Dt,
  CD: Ht,
  CF: kt,
  CG: Zt,
  CH: Wt,
  CI: _t,
  CK: zt,
  CL: Jt,
  CM: xt,
  CN: Yt,
  CO: Qt,
  CR: jt,
  CU: Xt,
  CV: qt,
  CW: no,
  CX: to,
  CY: oo,
  CZ: eo,
  DE: ao,
  DJ: so,
  DK: co,
  DM: ro,
  DO: io,
  DZ: uo,
  EC: lo,
  EE: po,
  EG: $o,
  EH: yo,
  ER: Co,
  ES: vo,
  ET: mo,
  FI: So,
  FJ: Mo,
  FK: fo,
  FM: go,
  FO: ho,
  FR: Io,
  GA: Go,
  GB: Bo,
  GD: To,
  GE: Ao,
  GF: Po,
  GG: bo,
  GH: Lo,
  GI: No,
  GL: Vo,
  GM: Ro,
  GN: Eo,
  GP: Ko,
  GQ: Fo,
  GR: Oo,
  GS: Uo,
  GT: wo,
  GU: Do,
  GW: Ho,
  GY: ko,
  HK: Zo,
  HM: Wo,
  HN: _o,
  HR: zo,
  HT: Jo,
  HU: xo,
  ID: Yo,
  IE: Qo,
  IL: jo,
  IM: Xo,
  IN: qo,
  IO: ne,
  IQ: te,
  IR: oe,
  IS: ee,
  IT: ae,
  JE: se,
  JM: ce,
  JO: re,
  JP: ie,
  KE: ue,
  KG: le,
  KH: de,
  KI: pe,
  KM: $e,
  KN: ye,
  KP: Ce,
  KR: ve,
  KW: me,
  KY: Se,
  KZ: Me,
  LA: fe,
  LB: ge,
  LC: he,
  LI: Ie,
  LK: Ge,
  LR: Be,
  LS: Te,
  LT: Ae,
  LU: Pe,
  LV: be,
  LY: Le,
  MA: Ne,
  MC: Ve,
  MD: Re,
  ME: Ee,
  MF: Ke,
  MG: Fe,
  MH: Oe,
  MK: Ue,
  ML: we,
  MM: De,
  MN: He,
  MO: ke,
  MP: Ze,
  MQ: We,
  MR: _e,
  MS: ze,
  MT: Je,
  MU: xe,
  MV: Ye,
  MW: Qe,
  MX: je,
  MY: Xe,
  MZ: qe,
  NA: na,
  NC: ta,
  NE: oa,
  NF: ea,
  NG: aa,
  NI: sa,
  NL: ca,
  NO: ra,
  NP: ia,
  NR: ua,
  NU: la,
  NZ: da,
  OM: pa,
  PA: $a,
  PE: ya,
  PF: Ca,
  PG: va,
  PH: ma,
  PK: Sa,
  PL: Ma,
  PM: fa,
  PN: ga,
  PR: ha,
  PS: Ia,
  PT: Ga,
  PW: Ba,
  PY: Ta,
  QA: Aa,
  RE: Pa,
  RO: ba,
  RS: La,
  RU: Na,
  RW: Va,
  SA: Ra,
  SB: Ea,
  SC: Ka,
  SD: Fa,
  SE: Oa,
  SG: Ua,
  SH: wa,
  SI: Da,
  SJ: Ha,
  SK: ka,
  SL: Za,
  SM: Wa,
  SN: _a,
  SO: za,
  SR: Ja,
  SS: xa,
  ST: Ya,
  SV: Qa,
  SX: ja,
  SY: Xa,
  SZ: qa,
  TC: ns,
  TD: ts,
  TF: os,
  TG: es,
  TH: as,
  TJ: ss,
  TK: cs,
  TL: rs,
  TM: is,
  TN: us,
  TO: ls,
  TR: ds,
  TT: ps,
  TV: $s,
  TW: ys,
  TZ: Cs,
  UA: vs,
  UG: ms,
  UM: Ss,
  US: Ms,
  UY: fs,
  UZ: gs,
  VA: hs,
  VC: Is,
  VE: Gs,
  VG: Bs,
  VI: Ts,
  VN: As,
  VU: Ps,
  WF: bs,
  WS: Ls,
  XK: Ns,
  YE: Vs,
  YT: Rs,
  ZA: Es,
  ZM: Ks,
  ZW: Fs
}, Us = "Andorra", ws = "دولة الإمارات العربية المتحدة", Ds = "افغانستان", Hs = "Antigua and Barbuda", ks = "Anguilla", Zs = "Shqipëria", Ws = "Հայաստան", _s = "Angola", zs = "Antarctica", Js = "Argentina", xs = "American Samoa", Ys = "Österreich", Qs = "Australia", js = "Aruba", Xs = "Åland", qs = "Azərbaycan", nc = "Bosna i Hercegovina", tc = "Barbados", oc = "Bangladesh", ec = "België", ac = "Burkina Faso", sc = "България", cc = "‏البحرين", rc = "Burundi", ic = "Bénin", uc = "Saint-Barthélemy", lc = "Bermuda", dc = "Negara Brunei Darussalam", pc = "Bolivia", $c = "Bonaire", yc = "Brasil", Cc = "Bahamas", vc = "ʼbrug-yul", mc = "Bouvetøya", Sc = "Botswana", Mc = "Белару́сь", fc = "Belize", gc = "Canada", hc = "Cocos (Keeling) Islands", Ic = "République démocratique du Congo", Gc = "Ködörösêse tî Bêafrîka", Bc = "République du Congo", Tc = "Schweiz", Ac = "Côte d'Ivoire", Pc = "Cook Islands", bc = "Chile", Lc = "Cameroon", Nc = "中国", Vc = "Colombia", Rc = "Costa Rica", Ec = "Cuba", Kc = "Cabo Verde", Fc = "Curaçao", Oc = "Christmas Island", Uc = "Κύπρος", wc = "Česká republika", Dc = "Deutschland", Hc = "Djibouti", kc = "Danmark", Zc = "Dominica", Wc = "República Dominicana", _c = "الجزائر", zc = "Ecuador", Jc = "Eesti", xc = "مصر‎", Yc = "الصحراء الغربية", Qc = "ኤርትራ", jc = "España", Xc = "ኢትዮጵያ", qc = "Suomi", nr = "Fiji", tr = "Falkland Islands", or = "Micronesia", er = "Føroyar", ar = "France", sr = "Gabon", cr = "United Kingdom", rr = "Grenada", ir = "საქართველო", ur = "Guyane française", lr = "Guernsey", dr = "Ghana", pr = "Gibraltar", $r = "Kalaallit Nunaat", yr = "Gambia", Cr = "Guinée", vr = "Guadeloupe", mr = "Guinea Ecuatorial", Sr = "Ελλάδα", Mr = "South Georgia", fr = "Guatemala", gr = "Guam", hr = "Guiné-Bissau", Ir = "Guyana", Gr = "香港", Br = "Heard Island and McDonald Islands", Tr = "Honduras", Ar = "Hrvatska", Pr = "Haïti", br = "Magyarország", Lr = "Indonesia", Nr = "Éire", Vr = "יִשְׂרָאֵל", Rr = "Isle of Man", Er = "भारत", Kr = "British Indian Ocean Territory", Fr = "العراق", Or = "ایران", Ur = "Ísland", wr = "Italia", Dr = "Jersey", Hr = "Jamaica", kr = "الأردن", Zr = "日本", Wr = "Kenya", _r = "Кыргызстан", zr = "Kâmpŭchéa", Jr = "Kiribati", xr = "Komori", Yr = "Saint Kitts and Nevis", Qr = "북한", jr = "대한민국", Xr = "الكويت", qr = "Cayman Islands", ni = "Қазақстан", ti = "ສປປລາວ", oi = "لبنان", ei = "Saint Lucia", ai = "Liechtenstein", si = "śrī laṃkāva", ci = "Liberia", ri = "Lesotho", ii = "Lietuva", ui = "Luxembourg", li = "Latvija", di = "‏ليبيا", pi = "المغرب", $i = "Monaco", yi = "Moldova", Ci = "Црна Гора", vi = "Saint-Martin", mi = "Madagasikara", Si = "M̧ajeļ", Mi = "Северна Македонија", fi = "Mali", gi = "မြန်မာ", hi = "Монгол улс", Ii = "澳門", Gi = "Northern Mariana Islands", Bi = "Martinique", Ti = "موريتانيا", Ai = "Montserrat", Pi = "Malta", bi = "Maurice", Li = "Maldives", Ni = "Malawi", Vi = "México", Ri = "Malaysia", Ei = "Moçambique", Ki = "Namibia", Fi = "Nouvelle-Calédonie", Oi = "Niger", Ui = "Norfolk Island", wi = "Nigeria", Di = "Nicaragua", Hi = "Nederland", ki = "Norge", Zi = "नेपाल", Wi = "Nauru", _i = "Niuē", zi = "New Zealand", Ji = "عمان", xi = "Panamá", Yi = "Perú", Qi = "Polynésie française", ji = "Papua Niugini", Xi = "Pilipinas", qi = "Pakistan", nu = "Polska", tu = "Saint-Pierre-et-Miquelon", ou = "Pitcairn Islands", eu = "Puerto Rico", au = "فلسطين", su = "Portugal", cu = "Palau", ru = "Paraguay", iu = "قطر", uu = "La Réunion", lu = "România", du = "Србија", pu = "Россия", $u = "Rwanda", yu = "العربية السعودية", Cu = "Solomon Islands", vu = "Seychelles", mu = "السودان", Su = "Sverige", Mu = "Singapore", fu = "Saint Helena", gu = "Slovenija", hu = "Svalbard og Jan Mayen", Iu = "Slovensko", Gu = "Sierra Leone", Bu = "San Marino", Tu = "Sénégal", Au = "Soomaaliya", Pu = "Suriname", bu = "South Sudan", Lu = "São Tomé e Príncipe", Nu = "El Salvador", Vu = "Sint Maarten", Ru = "سوريا", Eu = "Eswatini", Ku = "Turks and Caicos Islands", Fu = "Tchad", Ou = "Territoire des Terres australes et antarctiques fr", Uu = "Togo", wu = "ประเทศไทย", Du = "Тоҷикистон", Hu = "Tokelau", ku = "Timor-Leste", Zu = "Türkmenistan", Wu = "تونس", _u = "Tonga", zu = "Türkiye", Ju = "Trinidad and Tobago", xu = "Tuvalu", Yu = "臺灣", Qu = "Tanzania", ju = "Україна", Xu = "Uganda", qu = "United States Minor Outlying Islands", nl = "United States", tl = "Uruguay", ol = "O'zbekiston", el = "Vaticano", al = "Saint Vincent and the Grenadines", sl = "Venezuela", cl = "British Virgin Islands", rl = "United States Virgin Islands", il = "Việt Nam", ul = "Vanuatu", ll = "Wallis et Futuna", dl = "Samoa", pl = "Republika e Kosovës", $l = "اليَمَن", yl = "Mayotte", Cl = "South Africa", vl = "Zambia", ml = "Zimbabwe", q = {
  AD: Us,
  AE: ws,
  AF: Ds,
  AG: Hs,
  AI: ks,
  AL: Zs,
  AM: Ws,
  AO: _s,
  AQ: zs,
  AR: Js,
  AS: xs,
  AT: Ys,
  AU: Qs,
  AW: js,
  AX: Xs,
  AZ: qs,
  BA: nc,
  BB: tc,
  BD: oc,
  BE: ec,
  BF: ac,
  BG: sc,
  BH: cc,
  BI: rc,
  BJ: ic,
  BL: uc,
  BM: lc,
  BN: dc,
  BO: pc,
  BQ: $c,
  BR: yc,
  BS: Cc,
  BT: vc,
  BV: mc,
  BW: Sc,
  BY: Mc,
  BZ: fc,
  CA: gc,
  CC: hc,
  CD: Ic,
  CF: Gc,
  CG: Bc,
  CH: Tc,
  CI: Ac,
  CK: Pc,
  CL: bc,
  CM: Lc,
  CN: Nc,
  CO: Vc,
  CR: Rc,
  CU: Ec,
  CV: Kc,
  CW: Fc,
  CX: Oc,
  CY: Uc,
  CZ: wc,
  DE: Dc,
  DJ: Hc,
  DK: kc,
  DM: Zc,
  DO: Wc,
  DZ: _c,
  EC: zc,
  EE: Jc,
  EG: xc,
  EH: Yc,
  ER: Qc,
  ES: jc,
  ET: Xc,
  FI: qc,
  FJ: nr,
  FK: tr,
  FM: or,
  FO: er,
  FR: ar,
  GA: sr,
  GB: cr,
  GD: rr,
  GE: ir,
  GF: ur,
  GG: lr,
  GH: dr,
  GI: pr,
  GL: $r,
  GM: yr,
  GN: Cr,
  GP: vr,
  GQ: mr,
  GR: Sr,
  GS: Mr,
  GT: fr,
  GU: gr,
  GW: hr,
  GY: Ir,
  HK: Gr,
  HM: Br,
  HN: Tr,
  HR: Ar,
  HT: Pr,
  HU: br,
  ID: Lr,
  IE: Nr,
  IL: Vr,
  IM: Rr,
  IN: Er,
  IO: Kr,
  IQ: Fr,
  IR: Or,
  IS: Ur,
  IT: wr,
  JE: Dr,
  JM: Hr,
  JO: kr,
  JP: Zr,
  KE: Wr,
  KG: _r,
  KH: zr,
  KI: Jr,
  KM: xr,
  KN: Yr,
  KP: Qr,
  KR: jr,
  KW: Xr,
  KY: qr,
  KZ: ni,
  LA: ti,
  LB: oi,
  LC: ei,
  LI: ai,
  LK: si,
  LR: ci,
  LS: ri,
  LT: ii,
  LU: ui,
  LV: li,
  LY: di,
  MA: pi,
  MC: $i,
  MD: yi,
  ME: Ci,
  MF: vi,
  MG: mi,
  MH: Si,
  MK: Mi,
  ML: fi,
  MM: gi,
  MN: hi,
  MO: Ii,
  MP: Gi,
  MQ: Bi,
  MR: Ti,
  MS: Ai,
  MT: Pi,
  MU: bi,
  MV: Li,
  MW: Ni,
  MX: Vi,
  MY: Ri,
  MZ: Ei,
  NA: Ki,
  NC: Fi,
  NE: Oi,
  NF: Ui,
  NG: wi,
  NI: Di,
  NL: Hi,
  NO: ki,
  NP: Zi,
  NR: Wi,
  NU: _i,
  NZ: zi,
  OM: Ji,
  PA: xi,
  PE: Yi,
  PF: Qi,
  PG: ji,
  PH: Xi,
  PK: qi,
  PL: nu,
  PM: tu,
  PN: ou,
  PR: eu,
  PS: au,
  PT: su,
  PW: cu,
  PY: ru,
  QA: iu,
  RE: uu,
  RO: lu,
  RS: du,
  RU: pu,
  RW: $u,
  SA: yu,
  SB: Cu,
  SC: vu,
  SD: mu,
  SE: Su,
  SG: Mu,
  SH: fu,
  SI: gu,
  SJ: hu,
  SK: Iu,
  SL: Gu,
  SM: Bu,
  SN: Tu,
  SO: Au,
  SR: Pu,
  SS: bu,
  ST: Lu,
  SV: Nu,
  SX: Vu,
  SY: Ru,
  SZ: Eu,
  TC: Ku,
  TD: Fu,
  TF: Ou,
  TG: Uu,
  TH: wu,
  TJ: Du,
  TK: Hu,
  TL: ku,
  TM: Zu,
  TN: Wu,
  TO: _u,
  TR: zu,
  TT: Ju,
  TV: xu,
  TW: Yu,
  TZ: Qu,
  UA: ju,
  UG: Xu,
  UM: qu,
  US: nl,
  UY: tl,
  UZ: ol,
  VA: el,
  VC: al,
  VE: sl,
  VG: cl,
  VI: rl,
  VN: il,
  VU: ul,
  WF: ll,
  WS: dl,
  XK: pl,
  YE: $l,
  YT: yl,
  ZA: Cl,
  ZM: vl,
  ZW: ml
}, Sl = Object.entries(Os).sort(([, n], [, e]) => n.localeCompare(e)).map(([n, e]) => ({
  name: e !== q[n] ? `${q[n]} (${e})` : q[n],
  iso2: U(n),
  dialCode: `${zn(n)}`
})), J = class J {
  // eslint-disable-next-line class-methods-use-this
  async guess() {
    let e, a;
    try {
      e = await fetch(J.IP2C_URL), a = await e.text();
    } catch {
      return;
    }
    const r = a.toString().split(";");
    if (!(!r || r[0] !== "1"))
      return r[1];
  }
};
J.IP2C_URL = "https://ip2c.org/s";
let z = J;
class Ml extends z {
  constructor() {
    super(...arguments), this.memoCountry = void 0;
  }
  async guess() {
    return this.memoCountry || (this.memoCountry = await super.guess()), this.memoCountry;
  }
  setPreference(e) {
    this.memoCountry = e;
  }
}
const fl = {
  label: "Phone",
  ariaLabel: void 0,
  countryLabel: void 0,
  countryAriaLabel: (n) => `Country for ${n.label}`,
  placeholder: void 0,
  hint: void 0,
  invalidMessage: (n) => `The "${n.label}" field is not a valid phone number (example: ${n.example}).`,
  example: void 0,
  persistentPlaceholder: void 0,
  persistentHint: void 0,
  countryIconMode: void 0,
  allCountries: Sl,
  preferCountries: [],
  includeCountries: [],
  excludeCountries: [],
  defaultCountry: void 0,
  countryGuesser: new Ml(),
  guessCountry: !1,
  disableGuessLoading: !1,
  enableSearchingCountry: !1,
  displayFormat: "national",
  phoneValidator: (n) => n.valid
}, gn = { ...fl };
function gl(n) {
  Object.assign(gn, n);
}
function l(n) {
  return gn[n];
}
const hl = { key: 1 }, Il = { class: "v-phone-input__country__title" }, Gl = { class: "v-phone-input__country__append text-body-2" }, Bl = /* @__PURE__ */ tn({
  components: {
    VListItem: mn,
    VSelect: Jn,
    VTextField: vn
  },
  __name: "VPhoneInput",
  props: {
    label: { type: [Function, String], default: () => l("label") },
    ariaLabel: { type: [Function, String], default: () => l("ariaLabel") },
    countryLabel: { type: [Function, String], default: () => l("countryLabel") },
    countryAriaLabel: { type: [Function, String], default: () => l("countryAriaLabel") },
    placeholder: { type: [Function, String], default: () => l("placeholder") },
    hint: { type: [Function, String], default: () => l("hint") },
    invalidMessage: { type: [Function, String], default: () => l("invalidMessage") },
    example: { type: [String, Function], default: () => l("example") },
    appendIcon: { default: void 0 },
    appendInnerIcon: { default: void 0 },
    prependIcon: { default: void 0 },
    prependInnerIcon: { default: void 0 },
    rules: { default: () => [] },
    validateOn: { default: void 0 },
    countryIconMode: { type: [String, Object, Function], default: () => l("countryIconMode") },
    allCountries: { default: () => l("allCountries") },
    preferCountries: { default: () => l("preferCountries") },
    includeCountries: { default: () => l("includeCountries") },
    excludeCountries: { default: () => l("excludeCountries") },
    defaultCountry: { default: () => l("defaultCountry") },
    country: { default: "" },
    modelValue: { default: "" },
    wrapperProps: { default: () => ({}) },
    countryProps: { default: () => ({}) },
    phoneProps: { default: () => ({}) },
    displayFormat: { default: () => l("displayFormat") },
    enableSearchingCountry: { type: Boolean, default: () => l("enableSearchingCountry") },
    phoneValidator: { type: Function, default: l("phoneValidator") },
    countryGuesser: { default: () => l("countryGuesser") },
    guessCountry: { type: Boolean, default: () => l("guessCountry") },
    disableGuessLoading: { type: Boolean, default: () => l("disableGuessLoading") }
  },
  emits: ["update:modelValue", "update:country"],
  setup(n, { expose: e, emit: a }) {
    const r = [
      "id",
      "class",
      "style"
    ], d = [
      "variant",
      "flat",
      "tile",
      "density",
      "singleLine",
      "hideDetails",
      "direction",
      "reverse",
      "color",
      "bgColor",
      "theme",
      "disabled",
      "readonly",
      "rounded"
    ], o = n, $ = a, y = wn(), R = Dn(), {
      countriesCount: w,
      preferredCountries: E,
      otherCountries: B,
      guessingCountry: D,
      findCountry: T,
      firstCountry: H,
      setCountryPreference: p,
      guessCountry: K
    } = jn({ props: o }), F = S(null), C = S(null), { namespacedSlots: M } = tt(y, ["country"]), { countryIconComponent: I } = Xn({ props: o }), { countrySelectComponent: on } = qn({ props: o }), x = S(!1), Y = S([]), u = S(o.country), v = S(o.modelValue ?? ""), m = S(ln(_(""))), Q = (t) => Object.keys(R).reduce((s, i) => t(i) ? { ...s, [i]: R[i] } : s, {}), hn = c(() => ({
      ...Q((t) => r.indexOf(t) !== -1),
      ...o.wrapperProps
    })), In = c(() => T(o.defaultCountry) || H.value), A = c(() => T(u.value) || In.value), Gn = c(() => [...E.value.map((s) => ({ ...s, preferred: !0 })), ...B.value]), j = (t) => {
      var s, i;
      return ((s = t.number) == null ? void 0 : s[o.displayFormat]) ?? ((i = t.number) == null ? void 0 : i.input) ?? "";
    }, Bn = c(() => o.example !== void 0 ? typeof o.example == "function" ? o.example(A.value) : o.example : j(Sn(A.value.iso2))), Tn = c(() => {
      var s;
      const t = new Set(((s = o.validateOn) == null ? void 0 : s.split("")) || []);
      return t.size === 0 || t.has("input");
    }), f = nt({ props: o, country: A, example: Bn }), en = () => {
      var t;
      Tn.value && ((t = C.value) == null || t.validate());
    }, an = () => {
      const t = o.rules.map((s) => typeof s == "function" ? () => s(v.value ?? "", m.value, f.messageOptions.value) : s);
      f.invalidMessage.value ? Y.value = [
        ...t,
        () => !v.value || o.phoneValidator(m.value) || f.invalidMessage.value
      ] : Y.value = t;
    }, An = () => {
      o.phoneValidator(m.value) && (v.value = j(m.value));
    }, Pn = () => {
      var t, s;
      o.modelValue !== (((t = m.value.number) == null ? void 0 : t.input) ?? "") && o.modelValue !== (((s = m.value.number) == null ? void 0 : s.e164) ?? "") && (v.value = o.modelValue ?? "");
    }, bn = () => {
      o.country && o.country !== u.value && (u.value = o.country);
    };
    P(() => o.rules, an, { deep: !0, immediate: !0 }), P(() => o.displayFormat, An), P(() => o.modelValue, Pn), P(() => o.country, bn);
    const Ln = () => {
      an(), (v.value ?? "") !== "" && en();
    };
    P(f.invalidMessage, Ln);
    const Nn = () => {
      x.value = !0;
    }, Vn = () => {
      x.value = !1;
    }, sn = () => {
      m.value = ln(_((v.value ?? "").trim(), {
        regionCode: u.value
      })), o.phoneValidator(m.value) && (v.value = j(m.value));
    }, Rn = (t, s) => {
      u.value ? ($("update:country", u.value), p(u.value)) : dn(() => {
        u.value || (u.value = s);
      }), sn(), (v.value ?? "") !== "" && en();
    }, cn = (t, s) => {
      const i = t ?? "", g = s ?? "";
      if (i.length < g.length && i.replace(/\s+/g, "") === g.replace(/\s+/g, ""))
        return;
      if (i.startsWith("+")) {
        const k = _(i.trim()).regionCode;
        k && u.value !== k && T(k) && (u.value = k);
      }
      sn();
    }, En = () => {
      var g, b;
      const t = ((g = m.value.number) == null ? void 0 : g.input) ?? v.value, s = ((b = m.value.number) == null ? void 0 : b.e164) ?? t, i = o.phoneValidator(m.value);
      (o.modelValue !== t || o.modelValue !== s && i) && $("update:modelValue", (i ? s : t) ?? "");
    };
    P(u, Rn), P(v, cn), P(m, En, { deep: !0 });
    const Kn = async () => {
      if (u.value)
        return;
      if (w.value === 1) {
        u.value = H.value.iso2;
        return;
      }
      const t = await K();
      !u.value && t && (u.value = t), u.value = u.value || A.value.iso2;
    }, rn = c(() => ({
      ref: F,
      modelValue: u.value,
      label: f.countryLabel.value,
      "aria-label": f.countryAriaLabel.value,
      items: Gn.value,
      itemTitle: "name",
      itemValue: "iso2",
      loading: D.value,
      prependIcon: o.prependIcon,
      prependInnerIcon: o.prependInnerIcon,
      ...Q((t) => r.indexOf(t) === -1 && d.indexOf(t) !== -1),
      class: ["v-phone-input__country__input", {
        "v-phone-input--focused": x.value
      }],
      "onUpdate:modelValue": (t) => {
        u.value = t;
      },
      onFocus: Nn,
      onBlur: Vn
    })), un = c(() => ({
      ref: C,
      modelValue: v.value,
      label: f.label.value,
      "aria-label": f.ariaLabel.value,
      placeholder: f.placeholder.value,
      hint: f.hint.value,
      rules: Y.value,
      appendIcon: o.appendIcon,
      appendInnerIcon: o.appendInnerIcon,
      ...Q((t) => r.indexOf(t) === -1),
      validateOn: o.validateOn,
      class: "v-phone-input__phone__input",
      type: "tel",
      "onUpdate:modelValue": (t) => {
        v.value = t;
      }
    }));
    return Hn(() => {
      cn(v.value, void 0), dn(() => {
        Kn();
      });
    }), e({
      countryInputRef: F,
      phoneInputRef: C,
      isValid: c(() => {
        var t;
        return ((t = C.value) == null ? void 0 : t.isValid) ?? !0;
      }),
      errorMessages: c(() => {
        var t;
        return ((t = C.value) == null ? void 0 : t.errorMessages) ?? [];
      }),
      reset: async () => {
        var t;
        await ((t = C.value) == null ? void 0 : t.reset());
      },
      resetValidation: async () => {
        var t;
        await ((t = C.value) == null ? void 0 : t.resetValidation());
      },
      validate: async (t) => {
        var s;
        return await ((s = C.value) == null ? void 0 : s.validate(t)) ?? [];
      }
    }), (t, s) => (O(), pn("div", kn({
      class: [{ "v-phone-input--prepend-inner-icon": t.prependInnerIcon }, "v-phone-input"]
    }, hn.value), [
      G(t.$slots, "country-input", L(N({ props: rn.value })), () => [
        (O(), Z(W(h(on).type), L(N({
          ...h(on).props,
          ...t.countryProps,
          menuProps: {
            maxHeight: 300,
            contentClass: "v-phone-input__country__menu",
            closeOnContentClick: !0,
            ...(t.countryProps ? t.countryProps.menuProps : void 0) || {}
          },
          ...rn.value
        })), $n({
          selection: V(() => [
            G(t.$slots, "country-selection", { country: A.value }, () => [
              G(t.$slots, "country-icon", {
                country: A.value,
                decorative: !1
              }, () => [
                h(I) ? (O(), Z(W(h(I)), {
                  key: 0,
                  country: A.value,
                  decorative: !1
                }, null, 8, ["country"])) : (O(), pn("span", hl, X(`+${A.value.dialCode}`), 1))
              ])
            ])
          ]),
          item: V((i) => [
            Zn(h(mn), L(N(i.props)), {
              prepend: V(() => [
                G(t.$slots, "country-icon", {
                  country: i.item.raw,
                  decorative: !0
                }, () => [
                  h(I) ? (O(), Z(W(h(I)), {
                    key: 0,
                    country: i.item.raw,
                    decorative: !0
                  }, null, 8, ["country"])) : Wn("", !0)
                ])
              ]),
              title: V(() => [
                G(t.$slots, "country-title", {
                  country: i.item.raw
                }, () => [
                  yn("span", Il, X(i.item.raw.name), 1)
                ])
              ]),
              append: V(() => [
                G(t.$slots, "country-append", {
                  country: i.item.raw
                }, () => [
                  yn("span", Gl, " +" + X(i.item.raw.dialCode), 1)
                ])
              ]),
              _: 2
            }, 1040)
          ]),
          _: 2
        }, [
          Cn(h(M).country, (i, g) => ({
            name: g,
            fn: V((b) => [
              G(t.$slots, i, L(N(b)))
            ])
          }))
        ]), 1040))
      ]),
      G(t.$slots, "phone-input", L(N({ props: un.value })), () => [
        (O(), Z(W(h(vn)), L(N({
          ...t.phoneProps,
          ...un.value
        })), $n({ _: 2 }, [
          Cn(h(M).default, (i, g) => ({
            name: g,
            fn: V((b) => [
              G(t.$slots, g, L(N(b)))
            ])
          }))
        ]), 1040))
      ])
    ], 16));
  }
});
function bl(n) {
  return (e, a) => {
    a && console.warn("[v-phone-input] options must be passed as first argument of createVPhoneInput()"), gl(n || {}), e.component("VPhoneInput", Bl);
  };
}
class Ll extends z {
  constructor(e = {}) {
    super(), this.storage = e.storage || localStorage, this.key = e.key || "v_phone_input_country";
  }
  async guess() {
    const e = this.retrieveStoredCountry();
    if (e)
      return e;
    const a = await super.guess();
    return a && this.saveStoredCountry(a), a;
  }
  setPreference(e) {
    this.saveStoredCountry(e);
  }
  retrieveStoredCountry() {
    return this.storage.getItem(this.key) || void 0;
  }
  saveStoredCountry(e) {
    this.storage.setItem(this.key, e);
  }
  getStorage() {
    return this.storage;
  }
  getKey() {
    return this.key;
  }
}
function Nl(n, e) {
  var a, r;
  return ((a = n.number) == null ? void 0 : a[e]) || ((r = n.number) == null ? void 0 : r.input) || "";
}
function Vl(n) {
  return Sn(n);
}
function Rl(n, e) {
  return _((n || "").trim(), { regionCode: e });
}
export {
  fl as DEFAULT_OPTIONS,
  z as Ip2cCountryGuesser,
  Ml as MemoIp2cCountryGuesser,
  Ll as StorageMemoIp2cCountryGuesser,
  xn as VCountryIconSprite,
  Yn as VCountryIconSvg,
  Bl as VPhoneInput,
  Sl as countries,
  bl as createVPhoneInput,
  Nl as formatPhone,
  l as getOption,
  Vl as makeExample,
  Rl as makePhone,
  gl as mergeOptions
};
